import React from 'react';
import { BookOpen, PlusSquare, ClipboardList, GitMerge, FolderOpen, PlayCircle } from 'lucide-react';
import { useOnboarding } from '../context/OnboardingContext';
import './TutorialsPage.css';

const HelpCenter = () => {
  const { startTour, startOnboarding } = useOnboarding();

  const tours = [
    {
      id: 'offers',
      title: 'إضافة عرض',
      description: 'تعلّم كيف تضيف عقاراً جديداً خطوة بخطوة',
      icon: <PlusSquare size={32} />,
      color: '#1a5f4a',
    },
    {
      id: 'requests',
      title: 'إضافة طلب',
      description: 'تعلّم كيف تسجّل طلب عميل وتتابعه',
      icon: <ClipboardList size={32} />,
      color: '#0f7b5b',
    },
    {
      id: 'matching',
      title: 'المطابقة التلقائية',
      description: 'اكتشف كيف تعمل خاصية المطابقة بين العروض والطلبات',
      icon: <GitMerge size={32} />,
      color: '#14532d',
    },
    {
      id: 'catalog',
      title: 'الكتالوج',
      description: 'تعلّم كيف تنشئ كتالوج وتشاركه مع عملائك',
      icon: <FolderOpen size={32} />,
      color: '#065f46',
    },
  ];

  return (
    <div className="tutorials-page">
      <div className="page-header">
        <div className="header-title">
          <BookOpen size={28} />
          <h1>مركز المساعدة</h1>
        </div>
      </div>

      <div className="tutorials-intro">
        <h2>ابدأ جولة تفاعلية</h2>
        <p>اختر أحد المواضيع أدناه وسنأخذك في جولة داخل المنصة خطوة بخطوة</p>
      </div>

      <div className="help-tours-grid">
        {tours.map((tour) => (
          <button
            key={tour.id}
            className="help-tour-card"
            onClick={() => startTour(tour.id)}
            style={{ '--tour-color': tour.color }}
          >
            <div className="help-tour-icon">{tour.icon}</div>
            <div className="help-tour-body">
              <h3>{tour.title}</h3>
              <p>{tour.description}</p>
            </div>
            <div className="help-tour-arrow">
              <PlayCircle size={20} />
            </div>
          </button>
        ))}
      </div>

      <div className="help-full-tour">
        <button className="btn btn-primary help-full-tour-btn" onClick={() => startOnboarding()}>
          <PlayCircle size={20} />
          ابدأ الجولة الكاملة
        </button>
      </div>
    </div>
  );
};

export default HelpCenter;
